var exports = {
  "H": "xa15a2ab7--1bf7bf--aside",
};

module.exports = exports;
